
import _ from 'lodash';
import { PaginationRestDTO, PaginatedDataDTO, PaginationDTO } from '@bottega52/commons-pagination';
import { ICustomerContractServiceInDTO } from '../repository/jago/model/input/ICustomerContractServiceInDTO';
import { ICustomerContractServiceOutDTO } from '../repository/jago/model/output/ICustomerContractServiceOutDTO';
import { ICustomerContractServiceFormDTO } from '../repository/jago/model/input/ICustomerContractServiceFormDTO';

export enum CustomerServiceTypeOptions {
  RECURRING = 'RECURRING',
  ONEOFF = 'ONEOFF',
}

export enum CustomerContractServiceStatusOptions_RECURRING {
  WAITING_FOR_ACTIVATION = 'WAITING_FOR_ACTIVATION',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  CANCELLED = 'CANCELLED',
  INACTIVE = 'INACTIVE',
}

export enum CustomerContractServiceStatusOptions_ONEOFF {
  WAITING_TO_BE_DONE = 'WAITING_TO_BE_DONE',
  WORK_IN_PROGRESS = 'WORK_IN_PROGRESS',
  DONE = 'DONE',
  CANCELLED = 'CANCELLED',
}

export function decode(data: PaginationRestDTO<ICustomerContractServiceInDTO>): PaginatedDataDTO<ICustomerContractServiceInDTO> {
  const pagination: PaginationDTO = _.omit(data, 'content');
  return {
    content: data.content,
    pagination,
  };
}

export function decodeCustomerContractServiceContentToForm(data: ICustomerContractServiceInDTO): ICustomerContractServiceFormDTO {
  return {
    id: data.id,
    type: data.type,
    code: data.code,
    sellOutPONumber: data.sellOutPONumber,
    sfdcId: data.sfdcId,
    subject: data.subject,
    groupFamily: data.groupFamily,
    status: data.status,
    notes: data.notes,
    activationDate: data.activationDate,
    deactivationDate: data.deactivationDate,
    price: data.price,
    originalPrice: data.originalPrice,
    currency: data.currency,
    quantity: data.quantity,
    netPrice: data.netPrice,
  };
}

export function encodeCustomerContractServiceFromForm(data: ICustomerContractServiceFormDTO): ICustomerContractServiceOutDTO {
  let retVal: ICustomerContractServiceOutDTO = {
    type: data.type,
    code: data.code,
    sellOutPONumber: data.sellOutPONumber,
    sfdcId: data.sfdcId,
    subject: data.subject,
    groupFamily: data.groupFamily,
    status: data.status,
    notes: data.notes,
    activationDate: data.activationDate,
    deactivationDate: data.deactivationDate,
    price: data.price,
    originalPrice: data.originalPrice,
    currency: data.currency,
    quantity: data.quantity,
    netPrice: data.price,
  };
  return retVal;
}

export function encodeCustomerContractServiceInFromOut(data: ICustomerContractServiceInDTO): ICustomerContractServiceOutDTO {
  return {
    type: data.type,
    code: data.code,
    sellOutPONumber: data.sellOutPONumber,
    sfdcId: data.sfdcId,
    subject: data.subject,
    groupFamily: data.groupFamily,
    status: data.status,
    notes: data.notes,
    activationDate: data.activationDate,
    deactivationDate: data.deactivationDate,
    price: data.price,
    originalPrice: data.originalPrice,
    currency: data.currency,
    quantity: data.quantity,
    netPrice: data.price,
  };
}